module.exports = __webpack_public_path__ + "img/avatar_health_info.34474466.png";